import { call, fork, put, takeEvery } from 'redux-saga/effects';

import { loadSubaccounts } from '@/services/ElasticApi';
import { GetSubAccountsSuccess } from '@/store/subAccounts/actions';
import { GetSubAccountsAction } from '@/store/subAccounts/types';
import { Logger } from '@/services/errors/appLogger';

function* fetchSubAccounts(action: GetSubAccountsAction): any {
    const { payload } = action;
    try {
        const resp = yield call(loadSubaccounts, payload.limit, payload.offset);
        yield put(GetSubAccountsSuccess(resp.data));
    } catch (e) {
        Logger.error(e);
    }
}

function* watchSubAccountsFetchWatcher(): any {
    yield takeEvery('@@subaccounts/GET_SUBACCOUNTS', fetchSubAccounts);
}

const subAccountSagas = [fork(watchSubAccountsFetchWatcher)];

export default subAccountSagas;
